import { render, staticRenderFns } from "./UserRoleSelection.vue?vue&type=template&id=5245e832"
import script from "./UserRoleSelection.vue?vue&type=script&lang=js"
export * from "./UserRoleSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports